import { render } from "./request_otp.vue?vue&type=template&id=1cd4e91b&scoped=true"
import script from "./request_otp.vue?vue&type=script&lang=js"
export * from "./request_otp.vue?vue&type=script&lang=js"

import "./request_otp.vue?vue&type=style&index=0&id=1cd4e91b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd4e91b"]])

export default __exports__